import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Textarea = forwardRef((props, ref) => {
  const { className, hasError, id, label, message, ...rest } = props;

  const classNames = classnames('sage-textarea', className, {
    'sage-form-field--error': hasError,
  });
  return (
    <div className={classNames}>
      <textarea className="sage-textarea__field" placeholder={label} id={id} ref={ref} {...rest} />
      {label && (
        <label htmlFor={id} className="sage-textarea__label">
          {label}
        </label>
      )}
      {message && (
        <div className="sage-textarea__info">
          <div className="sage-textarea__message">{message}</div>
        </div>
      )}
    </div>
  );
});

Textarea.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  label: PropTypes.string,
  message: PropTypes.string,
  value: PropTypes.string,
};

Textarea.defaultProps = {
  className: null,
  hasError: false,
  label: null,
  message: null,
  value: '',
};

export default Textarea;
